<template>
  <div class="container">
    <div class="load" v-if="is_load"></div>
    <div class="group1">
      <span class="word1">欢迎登录</span>
      <!--        <van-field class="" v-model="value"  placeholder="请输入手机号" />-->
      <input class="info1" v-model="formData.mobile" placeholder="请输入手机号" />
      <div class="section1"></div>
      <div class="section2">
        <input class="word2" v-model="formData.verifyCode" placeholder="请输入图片验证码" />
        <div class="pic2" id="v_container"></div>
      </div>
      <div class="section3"></div>
      <div class="section4">
        <input class="txt1" v-model="formData.code" placeholder="请输入短信验证码" />
        <span class="word3" @click="smsSend" v-if="sign == false">获取验证码</span>
        <span class="word3" v-else style="background:#BBBBBB;color:#fff ">{{ codehtml }}S</span>
      </div>
      <div class="section5"></div>
      <button v-if="formData.code" class="section6" @click="land">登录</button>
      <button v-else class="section6 section7">登录</button>
      <!-- <div class="section8" @click="weixinFg">
        <div class="layer1"></div>
        <span class="word5">微信登录</span>
        <div class="layer2"></div>
      </div>
      <img
        @click="weixinFg"
        class="pic3"
        referrerpolicy="no-referrer"
        src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc83a8eb155ca6e51f86049eb2ae2ff045e1f55262274875ea78557f4b52f4ddd"
      />-->
    </div>
  </div>
</template>
<script>
import '@/public/gVerify' //引入图形验证
import { checkPhone } from '@/public/regular' //引入图形验证
import { weixinFg } from '@/public/public' //微信授权
import { Toast } from 'vant'
export default {
  name: 'login',
  data() {
    return {
      formData: {
        //form 提交
        mobile: '',
      },
      is_load: true, //加载中遮罩
      codehtml: 60, //倒计时秒
      sign: false, //倒计时
      verifyCode: '', //图形验证
    }
  },
  mounted() {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: '3000',
      loadingType: 'spinner',
      share_usesr_id: 0,
    })
    this.verifyCode = new GVerify('v_container')
    let search = window.location.href.split('?')[1]
      ? window.location.href.split('?')[1].split('code=')[1]
      : ''
    console.log(search)
    if (search) {
      let hrr = []
      let obj = {}
      //截取内部参数
      let params = localStorage
        .getItem('locationHref')
        .substr(localStorage.getItem('locationHref').indexOf('?') + 1)
      //逗号隔开
      let str = params.replace(/\&/g, ',')
      console.log(str)
      let crr = []
      str.split(',').map((i, index) => {
        crr.push(i.replace(/\=/g, ',').split())
      })
      crr.map((item) => {
        item.forEach((i) => {
          hrr.push(i.split(','))
        })
      })
      hrr.map((item) => {
        obj[item[0]] = item[1]
      })
      if (obj.uid) {
        this.share_usesr_id = obj.uid
      }
      console.log(obj.uid)
      //从地址栏去code 有就调取 getOpenid() 方法
      this.getOpenid(search.indexOf('&') > -1 ? search.split('&')[0] : search)
    } else {
      this.weixinFg()
      this.onceCode = ''
    }
  },
  methods: {
    //获取url字符串
    getStringFg(url) {
      console.log(obj)
    },
    getOpenid(key) {
      //用code 换取token
      this.onceCode = key
      this.http('Base.wxLogin', {
        code: key,
        share_user_id: this.share_usesr_id, //绑定关系
        share_staff_id: 0, //绑定关系
      }).then((res) => {
        if (res.status == 200) {
          res.content.mobile
            ? localStorage.getItem('locationHref')
              ? (window.location.href = localStorage.getItem('locationHref'))
              : this.$router.push({ path: 'home' })
            : (this.is_load = false)
        } else if (res) {
          if (res.status == 600) {
            //为600 code失效  每个code只能用一次
            this.$store.commit('LoginFailure', true) //弹框再次授权
          }
        }
      })
    },
    // 微信授权
    weixinFg,
    smsSend() {
      //获取验证码
      let { mobile, code, verifyCode } = this.formData
      console.log(this.verifyCode.options.code, verifyCode)
      if (checkPhone(mobile) == false) {
        this.$store.commit('increment', '手机号码有误请重填')
        return false
      } else if (!this.verifyCode.validate(verifyCode || '')) {
        this.$store.commit('increment', '图形验证码不正确')
        this.formData.verifyCode = ''
        return false
      }
      this.http('Base.smsSend', { mobile: mobile }).then((res) => {
        if (res.status == 200) {
          console.log(res, '3333333')
          this.codehtml = 60
          this.sign = true
          let tim = setInterval(() => {
            this.codehtml = this.codehtml - 1
            if (this.codehtml <= 0) {
              clearInterval(tim)
              this.sign = false
              return false
            }
          }, 1000)
          this.time = tim
        } else {
          this.$store.commit('increment', '图形验证码不正确')
        }
      })
    },
    //登陆按钮
    land(e) {
      let { mobile, code, verifyCode } = this.formData
      if (checkPhone(mobile) == false) {
        this.$store.commit('increment', '手机号码有误请重填')
        return false
      } else if (!this.verifyCode.validate(verifyCode || '')) {
        this.$store.commit('increment', '图形验证码不正确')
        this.formData.verifyCode = ''
        return false
      } else if (!code) {
        this.$store.commit('increment', '短信验证码不能为空')
        return false
      }
      this.http('Client.signUp', this.formData).then((res) => {
        if (res.status == 200) {
          console.log(res, 'response.data.content')
          this.$store.commit('increment', '成功')
          let contentListy = JSON.parse(localStorage.getItem('userInfo'))
          console.log(contentListy)
          contentListy.mobile = res.content.mobile
          contentListy = JSON.stringify(contentListy)
          localStorage.setItem('userInfo', contentListy)
          setTimeout(() => {
            if (localStorage.getItem('locationHref')) {
              //从本地存储储存东西
              window.location.href = localStorage.getItem('locationHref')
            } else {
              this.$router.push({ path: 'home' })
            }
          }, 1000)
        } else {
          this.$store.commit('increment', res.msg)
        }
      })
    },
  },
}
</script>
<style scoped lang="scss">
.container {
  //z-index: 1;
  position: relative;
  width: 750px;
  /*height: 1624px;*/
  background-color: rgba(255, 255, 255, 1);
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 14px;
}

.group1 {
  //z-index: auto;
  width: 750px;
  /*height: 1576px;*/
  display: flex;
  flex-direction: column;
}

.pic1 {
  //z-index: 17;
  width: 656px;
  height: 24px;
  align-self: flex-end;
  margin-right: 28px;
}

.img1 {
  //z-index: 42;
  width: 750px;
  height: 88px;
  align-self: center;
  margin-top: 30px;
}

.word1 {
  //z-index: 14;
  width: 216px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 54px;
  font-family: PingFangSC-Medium;
  line-height: 54px;
  text-align: left;
  align-self: flex-start;
  margin-left: 105px;
  margin-top: 88px;
}

.info1 {
  //z-index: 8;
  width: 100%;
  display: block;
  overflow-wrap: break-word;
  font-size: 30px;
  font-family: PingFangSC-Regular;
  line-height: 30px;
  text-align: left;
  align-self: flex-start;
  margin-left: 104px;
  margin-top: 99px;
}

.section1 {
  //z-index: 7;
  width: 540px;
  height: 1px;
  background-color: rgba(239, 239, 239, 1);
  align-self: center;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.section2 {
  //z-index: auto;
  width: 541px;
  height: 88px;
  margin-left: 104px;
  margin-top: 32px;
  flex-direction: row;
  display: flex;
  line-height: 88px;
  justify-content: space-between;
}

.word2 {
  //z-index: 4;
  width: 240px;
  display: block;
  overflow-wrap: break-word;
  font-size: 30px;
  font-family: PingFangSC-Regular;
  line-height: 88px;
  text-align: left;
  margin-top: 23px;
}

.pic2 {
  //z-index: 5;
  width: 178px;
  height: 76px;
}

.section3 {
  //z-index: 3;
  width: 540px;
  height: 1px;
  background-color: rgba(239, 239, 239, 1);
  align-self: center;
  margin-top: 1px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.section4 {
  //z-index: auto;
  width: 540px;
  height: 88px;
  line-height: 88px;
  margin-left: 104px;
  margin-top: 32px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}

.txt1 {
  //z-index: 15;
  width: 240px;
  display: block;
  overflow-wrap: break-word;
  font-size: 30px;
  font-family: PingFangSC-Regular;
  line-height: 88px;
  text-align: left;
}

.word3 {
  //z-index: 16;
  width: 180px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(238, 10, 36, 1);
  font-size: 30px;
  font-family: PingFangSC-Medium;
  line-height: 30px;
  text-align: center;
}

.section5 {
  //z-index: 9;
  width: 540px;
  height: 1px;
  background-color: rgba(239, 239, 239, 1);
  align-self: center;
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.section6 {
  //z-index: 59;
  height: 96px;
  border-radius: 48px;
  background-color: rgba(238, 10, 36, 1);
  align-self: center;
  margin-top: 119px;
  width: 540px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  color: #fff;
}

.word4 {
  //z-index: 60;
  width: 64px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 32px;
  font-family: PingFangSC-Regular;
  line-height: 44px;
  text-align: center;
}

.section7 {
  //z-index: 62;
  height: 96px;
  border-radius: 48px;
  background-color: rgba(200, 201, 204, 1);
  align-self: center;
  margin-top: 47px;
  width: 540px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.txt2 {
  //z-index: 63;
  width: 64px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 32px;
  font-family: PingFangSC-Regular;
  line-height: 44px;
  text-align: center;
}

.section8 {
  //z-index: auto;
  width: 388px;
  height: 30px;
  margin-left: 181px;
  margin-top: 131px;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
}

.layer1 {
  //z-index: 11;
  width: 120px;
  height: 1px;
  background-color: rgba(239, 239, 239, 1);
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.word5 {
  //z-index: 13;
  /*width: 88px;*/
  display: block;
  overflow-wrap: break-word;
  color: rgba(195, 195, 195, 1);
  font-size: 22px;
  font-family: PingFangSC-Regular;
  line-height: 30px;
  text-align: left;
}

.layer2 {
  //z-index: 12;
  width: 120px;
  height: 1px;
  background-color: rgba(239, 239, 239, 1);
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.pic3 {
  //z-index: 64;
  width: 80px;
  height: 80px;
  align-self: center;
  margin-top: 24px;
}

.img2 {
  //z-index: 54;
  width: 268px;
  height: 10px;
  align-self: center;
  margin-top: 255px;
}

.group1 input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #c3c3c3;
}
.group1 input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #c3c3c3;
}
.group1 input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #c3c3c3;
}
.group1 input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #c3c3c3;
}
</style>
